import { Icons } from 'constants/icons';
import { IBaseEntity } from './base';
import { ICertificateDAO } from './certificate';
import { IText, ITextDAO } from './text';
import { IOrganisationUserDAO, IOrgUserCertificate, IOrgUserCertificateDAO, IOrgUserVariableOverride } from './user';
import { IVariableDAO, VariableType } from './variable';
import { IImageDAO } from './image';
import { IVideoDAO } from './video';
import { ICourseNodeDAO } from './course';

export interface IVerification extends IBaseEntity {
  name: string;
  api: string;
  type: VerificationType;
}

export interface IVerificationDAO extends IVerification {
  entities: IVerificationEntity[];
}

export enum VerificationType {
  COOKIE = 0,
  EMAIL = 1,
  VERIF_EMAIL = 2,
  ACCOUNT = 3,
  DETAILS = 4,
  OPTIONS = 5,
  FEEDBACK = 6,
  PROGRESS_OBJECTIVE = 7,
  PROGRESS_CERTIFICATE = 8,
  TEXT = 9,
  PHOTO = 10,
  VIDEO = 11,
  CERTIFICATE_ASSIGNED = 12,
  CERTIFICATE_ISSUED = 13,
  PROGRESS_COURSE = 14,
}

export const verificationTypes = {
  COOKIE: 0,
  EMAIL: 1,
  VERIF_EMAIL: 2,
  ACCOUNT: 3,
  DETAILS: 4,
  OPTIONS: 5,
  FEEDBACK: 6,
  PROGRESS_OBJECTIVE: 7,
  PROGRESS_CERTIFICATE: 8,
  TEXT: 9,
  PHOTO: 10,
  VIDEO: 11,
};

export interface IVerificationEntity extends IBaseEntity {
  verificationId: number;
  certVariableId: number;
  certificateId: number;
  variableId: number;
  courseOutId: number;
  courseNodeId: number;
  name: string;
}

export interface IOrgUserVerification extends IBaseEntity {
  verificationRequestId: number;
  orgUserId: number;
}

export interface IOrgUserVerificationEntity extends IBaseEntity {
  orgUserVerificationId: number;
  verificationEntityId: number;
  serviceAttributeId: number;
  value: number;
}

export interface IVerificationRequest extends IBaseEntity {
  verification: IVerification;
  verificationId: number;
  certificateId: number;
  courseId: number;
  organisationUserId: number;
  courseProgressId: number;
  organisationUserCertificateId: number;
  serviceId: number;
  iconId: Icons;
  textId: number;
  imageId: number;
  courseNodeId: number;
  courseNodeToken: string;
  token: string;
  tokenCreated?: number;
  entities: IVerificationRequestEntity[];
  canContinue: boolean;
  type: VerificationRequestType;
}

export enum VerificationRequestStatus {
  DELETED = -1,
  NEW = 0,
  COMPLETE = 1,
  ERROR = 2,
}

export enum VerificationRequestType {
  REQUEST = 0,
  RESPONSE = 1,
  CERTIFICATE_ASSIGNED = 2,
  CERTIFICATE_ISSUED = 3,
  COURSE_ASSIGNED = 4
}

export interface IVerificationRequestDAO extends IVerificationRequest {
  orgUserId: number;
  serviceId: number;
  text: IText;
  image: IImageDAO;
  token: string;
  certificate: ICertificateDAO;
  certificateToken: string;
  courseNode: ICourseNodeDAO;
  organisationUser: IOrganisationUserDAO;
  organisationUserCertificate: IOrgUserCertificateDAO;
}

export interface IVerificationRequestEntity extends IBaseEntity {
  verificationRequestId: number;
  verificationEntityId: number;
  serviceAttributeId: number;
  value: number;
  pass: boolean;
  name: string;
  status: VerificationRequestStatus;
  type: VariableType | number;
  courseNodeEntityId: number;
  optionName: string;
  result: IVariableResult;
}

export interface IVariableResult {
  score: number;
  pass: boolean;
  variableOptionId: number;
  variableOptionName: string;
}

export interface IVerificationRequestEntityMedia extends IBaseEntity {
  verificationRequestEntityId: number;
  imageId: number;
  videoId: number;
  audioId: number;
  textId: number;
}

export interface IVerificationResponse extends IBaseEntity {
  verificationId: number;
  organisationUserId: number;
  verificationRequestId: number;
  verificationEntityId: number;
  courseNodeId: number;
  variableId: number;
  value: number;
  imageId: number;
  videoId: number;
  textId: number;
}

export interface IVerificationResponseDAO extends IVerificationResponse {
  organisationUserVariableOverrides: IOrgUserVariableOverride[];
  verification: IVerification;
  variable: IVariableDAO;
  organisationUser: IOrganisationUserDAO;
  organisationUserVariableOverride: IOrgUserVariableOverride;
  image: IImageDAO;
  video: IVideoDAO;
  text: ITextDAO;
}
